import { LuRefreshCcw } from 'react-icons/lu';
import { FormattedMessage } from 'react-intl';

import { useNetworkConnected } from '../hooks';

export const KioskNetworkErrorBanner = () => {
    const network = useNetworkConnected();

    if (network.connected && !network.checking) return null;

    return (
        <div
            className={`text-background-surface absolute bottom-0 z-50 flex w-full items-center justify-between gap-4 px-6 py-4 ${network.checking ? 'bg-status-warning' : 'bg-status-danger'}`}>
            <div className='grid min-w-0 flex-1 items-center'>
                <p
                    className={`col-start-1 row-start-1 ${network.checking ? 'invisible' : ''}`}
                    aria-hidden={network.checking}>
                    <FormattedMessage
                        id='kiosk.network-error-banner.message'
                        defaultMessage='No network connection. Contact your administrator or try again later.'
                        description='Message displayed when there is no network connection in the kiosk.'
                    />
                </p>
                <p
                    className={`col-start-1 row-start-1 ${network.checking ? '' : 'invisible'}`}
                    aria-hidden={!network.checking}>
                    <FormattedMessage
                        id='kiosk.network-error-banner.checking'
                        defaultMessage='Checking network connection...'
                        description='Message displayed while the kiosk verifies network connectivity after a refresh.'
                    />
                </p>
            </div>
            <button
                type='button'
                className='shrink-0'
                onClick={network.refresh}
                disabled={network.checking}
                aria-busy={network.checking}>
                <LuRefreshCcw className={`text-background-surface size-6 cursor-pointer ${network.checking ? 'animate-spin' : ''}`} />
            </button>
        </div>
    );
};
